import { StoreKeys } from './Constants';
import { StoreInterface } from './types';

export const getPreloadedState = (key: StoreKeys): Partial<StoreInterface> => {
  try {
    const persisted = localStorage.getItem(`persist:${key}`);
    if (!persisted) return {};

    const parsed = JSON.parse(persisted);
    const state: Partial<StoreInterface> = {};

    for (const key in parsed) {
      if (key === '_persist') continue;
      state[key as keyof StoreInterface] = safeParse(parsed[key]);
    }

    return state;
  } catch {
    return {};
  }
};

const safeParse = (value: string): any => {
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};
